import React, { useContext } from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { UserContext } from '../context/UserProvider';
import { Api } from '../componentes/Api';

const modelo = {
    nombre: "",
    correo: "",
    idRolNavigation: {
        idRol:0,
        descripcion: ""
    }
}
const NavBar = ({ data }) => {

    const { user} = useContext(UserContext);

    const [dataUser, setDataUser] = useState(modelo)
    const [impresion, setimpresion] = useState(data);
    const [Roles, setRoles] = useState([])

    const GetAsignacionModulo = async (u) => {
        let response = await fetch(Api + "Administracion/GetAsignacionModulo/" + u);
        if (response.ok) {
            let data = await response.json()
            setRoles(data)


        }
    }
    function validarRol(d) {
        var v = Roles.filter(x => x.moduloID == d).map(x => { return true });
        if (v.length == 0) {
            return false;
        } else { return true; }

    }
    function subvalidarRol(m, s) {
        var v = Roles.filter(x => x.moduloID == m && x.opcionMenu == s).map(x => { return true });
        if (v.length == 0) {
            return false;
        } else { return true; }

    }

    useEffect(() => {
        let dt = JSON.parse(user)
        setDataUser(dt)
        GetAsignacionModulo(dt.idUsuario)


    }, [])
    return (
        
        <ul hidden={impresion} className="navbar-nav bg-gradient-primary sidebar sidebar-dark accordion" id="accordionSidebar">

            <Link className="sidebar-brand d-flex align-items-center justify-content-center" to="/">
                <div className="sidebar-brand-icon">
                    <i className="fas fa-desktop"></i>
                </div>
                <div className="sidebar-brand-text mx-3">APATECH TOOLS</div>
            </Link>


            <hr className="sidebar-divider my-0" />


            {
                (dataUser.idRolNavigation.descripcion == "Administrador" || dataUser.idRolNavigation.descripcion == "Administrador D") &&
                <li className="nav-item" hidden>
                    <NavLink to="/dashboard" className="nav-link" >
                        <i className="fas fa-fw fa-tachometer-alt"></i>
                        <span>Dashboard</span>
                    </NavLink>
                </li>
            }
            <hr className="sidebar-divider" />
            {(subvalidarRol(1, 1)) &&
               // (dataUser.idRolNavigation.descripcion == "Administrador" || dataUser.idRolNavigation.descripcion == "Citas" || dataUser.idRolNavigation.descripcion == "VENTAS" || dataUser.idRolNavigation.descripcion == "Administrador D") &&
               (validarRol(1)) &&
                <li className="nav-item">
                    <a className="nav-link collapsed" href="#" data-toggle="collapse" data-target="#collapseCitas"
                        aria-expanded="true" aria-controls="collapseCitas">
                        <i className="fas fa-fw fa-cog"></i>
                        <span>Citas</span>
                    </a>
                    <div id="collapseCitas" className="collapse" aria-labelledby="headingTwo" data-parent="#accordionSidebar">
                            <div className="bg-white py-2 collapse-inner rounded" id="sidebarToggleTop1">
                            {(subvalidarRol(1, 1)) && <NavLink to="/Citas" className="collapse-item"  id="sidebarToggleTop" >Registro de Citas</NavLink>}
                            {(subvalidarRol(1, 2)) && <NavLink to="/reportecitas" className="collapse-item"  id="sidebarToggleTop">ReporteCitas</NavLink>}
                                {/*<NavLink to="/especialistas" className="collapse-item"  id="sidebarToggleTop">Especialista</NavLink>*/}
                                {/*<NavLink to="/producto" className="collapse-item"  id="sidebarToggleTop">Servicios</NavLink>*/}

                            </div>
                        </div>


                </li>
            }
            {
                //(dataUser.idRolNavigation.descripcion == "Administrador" || dataUser.idRolNavigation.descripcion == "VENTAS" || dataUser.idRolNavigation.descripcion == "Administrador D") &&
               (validarRol(2)) &&
                <li className="nav-item">
                    <a className="nav-link collapsed" href="#" data-toggle="collapse" data-target="#collapseVenta"
                        aria-expanded="true" aria-controls="collapseVenta">
                        <i className="fas fa-fw fa-tag"></i>
                        <span>Ventas</span>
                    </a>
                    <div id="collapseVenta" className="collapse" aria-labelledby="headingUtilities"
                        data-parent="#accordionSidebar">
                        <div className="bg-white py-2 collapse-inner rounded">
                            {(subvalidarRol(2, 1)) && <NavLink to="/venta" className="collapse-item"  id="sidebarToggleTop">Nueva Venta</NavLink>}
                            {/*<NavLink to="/ventacaja" className="collapse-item"  id="sidebarToggleTop">Caja Venta</NavLink>*/}
                                {(subvalidarRol(2, 2)) && <NavLink to="/historialventa" className="collapse-item"  id="sidebarToggleTop">Resumen de Venta</NavLink>}
                                {(subvalidarRol(2, 3)) && <NavLink to="/InformesVentas" className="collapse-item"  id="sidebarToggleTop">Informes</NavLink>}
                        </div>
                    </div>
                </li>

            }
            {
                //(dataUser.idRolNavigation.descripcion == "Administrador" || dataUser.idRolNavigation.descripcion == "VENTAS" || dataUser.idRolNavigation.descripcion == "Administrador D") &&
           (validarRol(3)) &&
                <li className="nav-item">
                    <a className="nav-link collapsed" href="#" data-toggle="collapse" data-target="#collapseInventario"
                        aria-expanded="true" aria-controls="collapseInventario">
                        <i className="fas fa-fw fa-box"></i>
                        <span>Inventario</span>
                    </a>
                    <div id="collapseInventario" className="collapse" aria-labelledby="headingUtilities"
                        data-parent="#accordionSidebar">
                        <div className="bg-white py-2 collapse-inner rounded">
                                {(subvalidarRol(3, 1)) && <NavLink to="/Articulos1" className="collapse-item"  id="sidebarToggleTop">Articulos</NavLink>}
                    
                            <div hidden>     <NavLink to="/producto" className="collapse-item"  id="sidebarToggleTop">Productos</NavLink>
                                <NavLink to="/categoria" className="collapse-item"  id="sidebarToggleTop">Categorias</NavLink></div>
                                {(subvalidarRol(3, 2)) &&  <NavLink to="/MovimientoAlmacen" className="collapse-item"  id="sidebarToggleTop">MovimientoAlmacen</NavLink>}
                                {(subvalidarRol(3, 3)) &&  <NavLink to="/Almacen" className="collapse-item"  id="sidebarToggleTop">Almacen</NavLink>}
                                {(subvalidarRol(3, 4)) && <NavLink to="/InformesInventario" className="collapse-item"  id="sidebarToggleTop">InformesInventario</NavLink>}
                        </div>
                    </div>
                </li>
            }
            {
                //    (dataUser.idRolNavigation.descripcion == "Administrador" || dataUser.idRolNavigation.descripcion == "DGII" || dataUser.idRolNavigation.descripcion == "VENTAS" || dataUser.idRolNavigation.descripcion == "Administrador D") &&
                (validarRol(4)) &&
                <li className="nav-item">
                    <a className="nav-link collapsed" href="#" data-toggle="collapse" data-target="#collapseCXC"
                            aria-expanded="true" aria-controls="collapseCXC">
                        <i className="fas fa-fw fa-cog"></i>
                        <span>Cuentas X Cobrar</span>
                    </a>
                        <div id="collapseCXC" className="collapse" aria-labelledby="headingTwo" data-parent="#accordionSidebar">
                        <div className="bg-white py-2 collapse-inner rounded" id="sidebarToggleTop1">
                            {(subvalidarRol(4, 1)) && <NavLink to="/Clientes1" className="collapse-item"  id="sidebarToggleTop">Clientes</NavLink>}
                                {(subvalidarRol(4, 2)) && <NavLink to="/RegistroCXC" className="collapse-item"  id="sidebarToggleTop">RegistroCXC</NavLink>}
                                {(subvalidarRol(4, 3)) && <NavLink to="/InformesCXC" className="collapse-item"  id="sidebarToggleTop">Informes</NavLink>}

                        </div>
                    </div>


                </li>
            }

            {
                //    (dataUser.idRolNavigation.descripcion == "Administrador" || dataUser.idRolNavigation.descripcion == "DGII" || dataUser.idRolNavigation.descripcion == "VENTAS" || dataUser.idRolNavigation.descripcion == "Administrador D") &&
                (validarRol(5)) &&
                <li className="nav-item">
                    <a className="nav-link collapsed" href="#" data-toggle="collapse" data-target="#collapseCXP"
                        aria-expanded="true" aria-controls="collapseCXP">
                        <i className="fas fa-fw fa-cog"></i>
                        <span>Cuentas X Pagar</span>
                    </a>
                    <div id="collapseCXP" className="collapse" aria-labelledby="headingTwo" data-parent="#accordionSidebar">
                        <div className="bg-white py-2 collapse-inner rounded" id="sidebarToggleTop1">
                                {(subvalidarRol(5, 1)) && <NavLink to="/Suplidor" className="collapse-item"  id="sidebarToggleTop">Suplidor</NavLink>}
                                {(subvalidarRol(5, 2)) && <NavLink to="/RegistroCXP" className="collapse-item"  id="sidebarToggleTop">RegistroCXP</NavLink>}
                                {(subvalidarRol(5, 3)) && <NavLink to="/InformesCXP" className="collapse-item"  id="sidebarToggleTop">Informes</NavLink>}

                        </div>
                    </div>


                </li>
            }
           
                  {
            //    (dataUser.idRolNavigation.descripcion == "Administrador" || dataUser.idRolNavigation.descripcion == "DGII" || dataUser.idRolNavigation.descripcion == "VENTAS" || dataUser.idRolNavigation.descripcion == "Administrador D") &&
                (validarRol(6)) &&
                <li className="nav-item">
                        <a className="nav-link collapsed" href="#" data-toggle="collapse" data-target="#collapseDGII"
                            aria-expanded="true" aria-controls="collapseDGII">
                        <i className="fas fa-fw fa-cog"></i>
                        <span>DGII</span>
                    </a>
                        <div id="collapseDGII" className="collapse" aria-labelledby="headingTwo" data-parent="#accordionSidebar">
                            <div className="bg-white py-2 collapse-inner rounded" id="sidebarToggleTop1">
                                {(subvalidarRol(6, 1)) && <NavLink to="/RegristroFacturaNCF" className="collapse-item"  id="sidebarToggleTop">Regristro Factura NCF</NavLink>}
                             
                            </div>
                        </div>


                </li>
            }
            {
              //  (dataUser.idRolNavigation.descripcion == "Administrador" || dataUser.idRolNavigation.descripcion == "Consultorio" || dataUser.idRolNavigation.descripcion == "Administrador D" ) &&
               (validarRol(7)) &&
                <li className="nav-item">
                    <a className="nav-link collapsed" href="#" data-toggle="collapse" data-target="#collapseConsultorio "
                        aria-expanded="true" aria-controls="collapseConsultorio ">
                        <i className="fas fa-fw fa-cog"></i>
                        <span>Medical</span>
                    </a>
                    <div id="collapseConsultorio" className="collapse" aria-labelledby="headingTwo" data-parent="#accordionSidebar">
                        <div className="bg-white py-2 collapse-inner rounded" id="sidebarToggleTop1">
                            {(subvalidarRol(7, 1)) && <NavLink to="/Gastro" className="collapse-item"  id="sidebarToggleTop">Gastro</NavLink>}
                                {(subvalidarRol(7, 9)) && <NavLink to="/Nutricion" className="collapse-item"  id="sidebarToggleTop">Nutricion</NavLink>}
                           {(subvalidarRol(7, 10)) && <NavLink to="/Odontologia" className="collapse-item"  id="sidebarToggleTop">Odontologia</NavLink>}
                               

                                  {(subvalidarRol(7, 2)) && <NavLink to="/Ginecologo" className="collapse-item"  id="sidebarToggleTop">Ginecologo</NavLink>}
                                {/*{(subvalidarRol(5, 1)) && <NavLink to="/Ginecologia" className="collapse-item"  id="sidebarToggleTop">Ginecologia</NavLink>}*/}
                              {(subvalidarRol(7, 3)) && <NavLink to="/CVentas" className="collapse-item"  id="sidebarToggleTop">Facturacion</NavLink>}
                                {(subvalidarRol(7, 3)) && <NavLink to="/Reclamaciones" className="collapse-item" id="sidebarToggleTop">Reclamaciones</NavLink>}
                                {(subvalidarRol(7, 3)) && <NavLink to="/ReportesC" className="collapse-item" id="sidebarToggleTop">Reportes</NavLink>}

                                {(subvalidarRol(7, 4)) && <NavLink to="/HistorialVentaC" className="collapse-item" id="sidebarToggleTop">Consulta Factura</NavLink>}
                                {(subvalidarRol(7, 5)) && <NavLink to="/Doctores" className="collapse-item"  id="sidebarToggleTop">Doctores</NavLink>}
                            {(subvalidarRol(7, 6)) && <NavLink to="/Seguros" className="collapse-item"  id="sidebarToggleTop">Seguros</NavLink>}

                        
                            
                            {(subvalidarRol(7, 7)) && <NavLink to="/Medicamentos" className="collapse-item"  id="sidebarToggleTop">Medicamentos</NavLink>}
                            {(subvalidarRol(7, 8)) && <NavLink to="/Toxico" className="collapse-item"  id="sidebarToggleTop">Toxico</NavLink>}
                                {(subvalidarRol(7, 8)) && <NavLink to="/Articulos1" className="collapse-item"  id="sidebarToggleTop">Articulos</NavLink>}

                        </div>
                    </div>


                </li>
            }
            {
                //  (dataUser.idRolNavigation.descripcion == "Administrador" || dataUser.idRolNavigation.descripcion == "Consultorio" || dataUser.idRolNavigation.descripcion == "Administrador D" ) &&
                (validarRol(9)) &&
                <li className="nav-item">
                    <a className="nav-link collapsed" href="#" data-toggle="collapse" data-target="#collapsePrestamo "
                            aria-expanded="true" aria-controls="collapsePrestamo">
                        <i className="fas fa-fw fa-cog"></i>
                        <span>Prestamos</span>
                    </a>
                        <div id="collapsePrestamo" className="collapse" aria-labelledby="headingTwo" data-parent="#accordionSidebar">
                        <div className="bg-white py-2 collapse-inner rounded" id="sidebarToggleTop1">
                            {(subvalidarRol(9, 1)) && <NavLink to="/Prestamo" className="collapse-item"  id="sidebarToggleTop">Prestamos</NavLink>}
                                {(subvalidarRol(9, 2)) && <NavLink to="/ConsultaFactura" className="collapse-item"  id="sidebarToggleTop">ConsultaFactura</NavLink>}
                          
                        </div>
                    </div>


                </li>
            }
            {
                (dataUser.idRolNavigation.descripcion == "Administrador" || dataUser.idRolNavigation.descripcion == "Transporte") &&
                <li className="nav-item">
                    <a className="nav-link collapsed" href="#" data-toggle="collapse" data-target="#collapseTransporte "
                        aria-expanded="true" aria-controls="collapsTransporte ">
                        <i className="fas fa-fw fa-cog"></i>
                        <span>Transporte</span>
                    </a>
                    <div id="collapseTransporte" className="collapse" aria-labelledby="headingTwo" data-parent="#accordionSidebar">
                            <div className="bg-white py-2 collapse-inner rounded" id="sidebarToggleTop1">
                                <NavLink to="/Tventa" className="collapse-item"  id="sidebarToggleTop">Nueva Venta</NavLink>

                            <NavLink to="/Orden" className="collapse-item"  id="sidebarToggleTop">Orden</NavLink>
                                <NavLink to="/Articulos" className="collapse-item"  id="sidebarToggleTop">Articulos</NavLink>
                            <NavLink to="/T_Cliente" className="collapse-item"  id="sidebarToggleTop">Clientes</NavLink>
                            <NavLink to="/TPrestamo" className="collapse-item"  id="sidebarToggleTop">Pretamos</NavLink>

                        </div>
                    </div>


                </li>
            }
                {
             (dataUser.idRolNavigation.descripcion == "Administrador") &&
                 <li className="nav-item">
                    <a className="nav-link collapsed" href="#" data-toggle="collapse" data-target="#collapseCXC "
                        aria-expanded="true" aria-controls="collapseCXC ">
                        <i className="fas fa-fw fa-cog"></i>
                        <span>CXC</span>
                    </a>
                    <div id="collapseCXC" className="collapse" aria-labelledby="headingTwo" data-parent="#accordionSidebar">
                        <div className="bg-white py-2 collapse-inner rounded" id="sidebarToggleTop1">
                            <NavLink to="/Clientes" className="collapse-item"  id="sidebarToggleTop">Clientes</NavLink>

                        </div>
                    </div>


                </li>
            }

            <hr className="sidebar-divider" />
            {
              //  (dataUser.idRolNavigation.descripcion == "Administrador" || dataUser.idRolNavigation.descripcion == "Administrador D") &&
                (validarRol(8)) &&     <li className="nav-item">
                    <a className="nav-link collapsed" href="#" data-toggle="collapse" data-target="#collapseUsuario"
                        aria-expanded="true" aria-controls="collapseUsuario">
                        <i className="fas fa-fw fa-cog"></i>
                        <span>Ajustes</span>
                    </a>
                    <div id="collapseUsuario" className="collapse" aria-labelledby="headingTwo" data-parent="#accordionSidebar">
                        <div className="bg-white py-2 collapse-inner rounded">
                            {(subvalidarRol(8, 1)) && <NavLink to="/usuario" className="collapse-item"  id="sidebarToggleTop">Usuarios</NavLink>}
                            {(subvalidarRol(8, 2)) && <NavLink to="/empresas" className="collapse-item"  id="sidebarToggleTop">Empresas</NavLink>}
                            {(subvalidarRol(8, 3)) && <NavLink to="/secuencianumerica" className="collapse-item"  id="sidebarToggleTop">Secuencia Numerica</NavLink>}
                            {(subvalidarRol(8, 3)) && <NavLink to="/RPD" className="collapse-item"  id="sidebarToggleTop">Reporteria</NavLink>}
                            </div>
                    </div>
                </li>
            }
            
         
            {(dataUser.idRolNavigation.descripcion == "Administrador" || dataUser.idRolNavigation.descripcion == "Iglesia") &&
                <li className="nav-item">
                    <a className="nav-link collapsed" href="#" data-toggle="collapse" data-target="#collapseIglesia"
                        aria-expanded="true" aria-controls="collapseIglesia">
                        <i className="fas fa-fw fa-tag"></i>
                        <span>Iglesia</span>
                    </a>
                    <div id="collapseIglesia" className="collapse" aria-labelledby="headingUtilities"
                        data-parent="#accordionSidebar">
                        <div className="bg-white py-2 collapse-inner rounded">
                            <NavLink to="/Amigos" className="collapse-item"  id="sidebarToggleTop">Amigos</NavLink>
                        </div>
                    </div>
                </li>

            }
           
           
            {(dataUser.idRolNavigation.descripcion == "Administrador") &&
                <li className="nav-item">
                    <a className="nav-link collapsed" href="#" data-toggle="collapse" data-target="#collapseReporte"
                        aria-expanded="true" aria-controls="collapseReporte">
                        <i className="fas fa-fw fa-chart-area"></i>
                        <span>Reportes</span>
                    </a>
                    <div id="collapseReporte" className="collapse" aria-labelledby="headingUtilities"
                        data-parent="#accordionSidebar">
                        <div className="bg-white py-2 collapse-inner rounded">
                            <NavLink to="/reporteventa" className="collapse-item"  id="sidebarToggleTop">Reporte Venta</NavLink>
                        </div>
                    </div>
                </li>
            }
            


            <hr className="sidebar-divider d-none d-md-block" />

            <div className="text-center d-none d-md-inline">
                <button className="rounded-circle border-0" id="sidebarToggle"></button>
            </div>

        </ul>
        )
}

export default NavBar;